<template>
  <div>
    <div class="search-wrap">
      <p v-if="validation_no_post_code" class="validation">Please enter a valid postcode.</p>
      <InputSearch  @input="getSearchValue($event)" class="mb-5" @keyup.enter.native="search" v-model="searchValue" />
      <div class="columns is-gapless is-mobile is-centered">
        <div
          class="column is-4 has-text-centered"
          v-for="(range, index) in ranges"
          :key="index"
        >
          <button
            :class="['button', 'is-medium', 'is-rounded', 'range-button', isSelected(range) ? 'active-range-button' : 'not-active-range-button', 'w-90', ]"
            @click="selectRange($event, range)"
          >
            {{ range | formatRange }}
          </button>
        </div>
      </div>
      <div class="has-text-centered">
        <button
          class="button is-large is-rounded search-button slide-left is-fullwidth "
          :class="{ 'is-loading': gymApiStatus === 'LOADING' }"
          @click="search($event)"
          v-if="buttonRender"
        >
          Search
        </button>
      </div>
      <!-- <p v-show="validation_no_post_code" class="help is-danger mb-1">Please enter a valid postcode.</p> -->
    </div>
  </div>
</template>

<script>
import InputSearch from '@/components/atoms/InputSearch.vue';
import { mapMutations, mapActions, mapState } from 'vuex';

export default {
  components: {
    InputSearch,
  },
  data() {
    return {
      range_button_selected: [],
      selected_range: 1,
      searchValue: '',
      buttonRender: true,
      validation_no_post_code: false,
      validation_blank: false,
    };
  },
  computed: {
    ...mapState(['gymApiStatus']),
  },
  props: {
    ranges: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...mapMutations(['storeGyms']),
    ...mapActions(['findGyms', 'findAllGyms']),
    updateRange(val) {
      this.selected_range = val;
      this.selectRange(val);
    },
    selectRange(event, range) {
      event.target.blur();
      this.selected_range = range;
      this.$store.commit('storeRange', this.selected_range);
    },
    isSelected(range) {
      if (range === this.selected_range) {
        return true;
      } else {
        return false;
      }
    },

    loadingPromise() {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.buttonRender = false;
          this.loading = false;
          this.buttonRender = true;
          resolve();
        }, 1500);
      });
    },

    async search(event) {
      try {
        event.target.blur();
        let postCodeRegex = /^(([A-Za-z]{1,2}[0-9][A-Za-z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Za-z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Za-z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/;
        if (!postCodeRegex.test(this.searchValue)) {
          this.validation_no_post_code = true;
          this.searchValue = '';
          throw 'Invalid postcode';
        }
        // this.buttonRender = false;
        // this.loading = true;
        // this.buttonRender = true;
        // await this.loadingPromise();
        this.$store.commit('storeRange', this.selected_range);
        this.$store.commit('storeSearch', this.searchValue);
        if (this.searchValue) {
          this.validation_no_post_code = false;
          await this.findGyms();
        } else {
          this.validation_no_post_code = false;
          await this.findAllGyms();
        }
      } catch (error) {
        console.log(error);
      }
    },
    getSearchValue($event) {
      this.searchValue = $event;
    },
  },
};
</script>

<style scoped>


.validation {
  color: red;
  font-size: 0.75rem;
  padding: 1rem;
}

.search {
  font-size: 4rem;
}

.search-wrap {
  padding: 0.5rem;
}

.column {
  padding: 0.75rem !important;
}

.range-button, .search-button {
    box-shadow: 0 5px 10px 0 rgba(0,0,0,0.2)
}

.w-90 {
  width: 90%;
}
</style>
